export const environment = {
  production: true,
  apiUrl:'/api/',
  uploadUrl:'/',
  uploadTempUrl:'/adjuntos/temp/',
  signalrHubUrl:'/'
};
